import { sections } from '..';
import experiment from 'experiment';

export const isNewZoomLabelEnabled = () =>
  sections.isSectionsEnabled() &&
  experiment.isOpen('se_scaleForStageShiftingPanels');
